import React from "react";
import FormInput from "../FormInput/FormInput";

const ForgotPass = () => {
  return (
    <>
      <div className="dg__account mt-5">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <FormInput
                tag={"input"}
                type={"text"}
                name={"forgot-password"}
                placeholder={"Enter your email"}
              />
            </div>

            <div className="col-12">
              <div className="contact-btn">
                <button type="submit">
                  Submit
                  <span className="ti-arrow-right" />
                </button>
              </div>

              <div className="form-message" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPass;
